module.exports = __webpack_public_path__ + "img/balkam.2a7adc70.svg";